import React from "react";
import "./Badge.css";

function Badge(props) {
    const variant = props.variant || "default";
    const text = props.text || "";

    return (
        <span className={`new-badge new-badge-${variant}`}>
            {text}
        </span>
    );
}

export default Badge;